// dark google-maps palette for the midnight theme (FI-1869 round 15).
// same restraint as the light array each map component carries (muted
// landscape, quiet roads, transit/poi off) resolved into the midnight
// navy family. components keep their light `mapStyle` untouched and swap
// this in via a `themed_map_options` computed when the profile theme is
// midnight -- only on in-shell map pages; standalone/public map pages
// (tracking links, bus tracker, kiosk boards) stay light by doctrine.
export const DARK_MAP_STYLES = [
  {
    featureType: 'landscape',
    stylers: [{ color: '#141c26' }]
  },
  {
    featureType: 'water',
    stylers: [{ color: '#0a141f' }]
  },
  {
    featureType: 'landscape.natural.terrain',
    stylers: [{ color: '#16231d' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#2a323c' }]
  },
  {
    featureType: 'road',
    elementType: 'geometry.fill',
    stylers: [{ color: '#1f2833' }]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{ color: '#33302a' }]
  },
  {
    featureType: 'transit',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'poi',
    stylers: [{ visibility: 'off' }]
  },
  // label inks: the defaults assume a light basemap
  {
    elementType: 'labels.text.fill',
    stylers: [{ color: '#93a5b7' }]
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#0f1a28' }]
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#2a323c' }]
  }
]
